export enum BulkUploadQueueType {
  record = 'record',
  file = 'file',
  sidedrawer = 'sidedrawer',
}
